import Form from './Form.connect';

export default Form;
